import React, { Fragment } from "react";
import Close from "jsx:../../assets/svgs/close.svg";

import "./styles.styl";

const ShopBanner = ({
  bannerText,
  bannerColor,
  handleCloseBanner,
  ownerlessShop,
}) => {
  const bannerTextWithLineBreaks = ({ text }) => {
    if (!text) return null;
    const textArray = text.split("\n");
    return (
      <>
        {textArray.map((line, i) => (
          <Fragment key={i}>
            {line}
            <br />
          </Fragment>
        ))}
      </>
    );
  };

  return (
    <div className="shop_banner__main">
      {!ownerlessShop && (
        <Close className="shop_banner__close" onClick={handleCloseBanner} />
      )}
      <div
        className="shop_banner__container"
        style={{ backgroundColor: bannerColor }}
      >
        {bannerTextWithLineBreaks({ text: bannerText })}
      </div>
    </div>
  );
};

export default ShopBanner;
